import { flatbizDate } from '@flatbiz/utils';
import { CalendarProps, TMonthDayItem, TMonthItem } from '../types';

/**
 * 计算两个日期的月份差值
 * @param minDate
 * @param maxDate
 * @returns
 */
export const calculateDateRangeMonthCount = (minDate: string, maxDate: string) => {
  const minDateDetail = flatbizDate.detail(minDate);
  const maxDateDetail = flatbizDate.detail(maxDate);
  // 得到月数
  const minDateMonthNum = minDateDetail.y * 12 + minDateDetail.m;
  const maxDateMonthNum = maxDateDetail.y * 12 + maxDateDetail.m;
  return Math.abs(minDateMonthNum - maxDateMonthNum);
};

/**
 * 计算月份周期数据
 */
const calculateMonthWeekList = (
  monthDate: string | Date,
  options: {
    weekType: CalendarProps['weekType'];
    isFill: CalendarProps['isFill'];
    minDate: string;
    maxDate: string;
    prevFill?: boolean;
    nextFill?: boolean;
  },
) => {
  const dateDetail = flatbizDate.detail(monthDate);
  //一个月有多少天
  const monthDayTotal = new Date(dateDetail.y, dateDetail.m, 0).getDate();
  let monthWeekList = [] as TMonthDayItem[];
  const monthFirstDayWeek = flatbizDate.detail(new Date(dateDetail.y, dateDetail.m - 1, 1)).week;
  for (let index = 0; index < monthDayTotal; index++) {
    const loopCurrentDate = new Date(dateDetail.y, dateDetail.m - 1, index + 1);
    const inScope = flatbizDate.in(loopCurrentDate, options.minDate, options.maxDate);
    const loopCurrentDateDetail = flatbizDate.detail(loopCurrentDate);
    monthWeekList.push({
      label: `${index + 1}`,
      week: loopCurrentDateDetail.week,
      inScope,
      date: flatbizDate.format(loopCurrentDate),
    });
  }

  if (options.prevFill !== false) {
    // 前补齐
    let headEmptyTotal = 0;
    if (options.weekType === 'week7-first') {
      headEmptyTotal = monthFirstDayWeek === 7 ? 0 : monthFirstDayWeek;
    } else {
      headEmptyTotal = monthFirstDayWeek - 1;
    }
    if (headEmptyTotal > 0) {
      const headEmptyDays: TMonthDayItem[] = [];
      // 上个月
      const prevMonth = flatbizDate.detail(flatbizDate.update(monthDate, 'm', -1));
      // 上个月有多少天
      const prevMonthDayTotal = new Date(prevMonth.y, prevMonth.m, 0).getDate();
      for (let index = prevMonthDayTotal - headEmptyTotal; index < prevMonthDayTotal; index++) {
        const loopCurrentDate = flatbizDate.detail(new Date(prevMonth.y, prevMonth.m - 1, index + 1));
        const inScope = flatbizDate.in(loopCurrentDate.instance, options.minDate, options.maxDate);
        headEmptyDays.push({
          label: `${index + 1}`,
          week: loopCurrentDate.week,
          inScope,
          date: flatbizDate.format(loopCurrentDate.instance),
          type: options.isFill ? 'prev' : 'empty',
        });
      }
      monthWeekList = headEmptyDays.concat(monthWeekList);
    }
  }

  if (options.nextFill !== false) {
    // 后补齐
    // 一个月最后一天数据
    const monthLastDayWeek = flatbizDate.detail(new Date(dateDetail.y, dateDetail.m - 1, monthDayTotal)).week;
    let tailEmptyTotal = 0;
    if (options.weekType === 'week7-first') {
      tailEmptyTotal = monthLastDayWeek === 7 ? 6 : 6 - monthLastDayWeek;
    } else {
      tailEmptyTotal = 7 - monthLastDayWeek;
    }
    if (tailEmptyTotal > 0) {
      const tailEmptyDays: TMonthDayItem[] = [];
      // 下一月
      const nextMonth = flatbizDate.detail(flatbizDate.update(monthDate, 'm', 1));
      for (let index = 0; index < tailEmptyTotal; index++) {
        const loopCurrentDate = flatbizDate.detail(new Date(nextMonth.y, nextMonth.m - 1, index + 1));
        const inScope = flatbizDate.in(loopCurrentDate.instance, options.minDate, options.maxDate);
        tailEmptyDays.push({
          label: `${index + 1}`,
          week: loopCurrentDate.week,
          inScope,
          date: flatbizDate.format(loopCurrentDate.instance),
          type: options.isFill ? 'next' : 'empty',
        });
      }
      monthWeekList = monthWeekList.concat(tailEmptyDays);
    }
  }
  return monthWeekList;
};

export const calculateMonthList = (
  minDate: string,
  maxDate: string,
  weekType: CalendarProps['weekType'],
  isFill: CalendarProps['isFill'],
) => {
  const count = calculateDateRangeMonthCount(minDate, maxDate);
  const monthList = [] as TMonthItem[];
  for (let index = 0; index < count + 1; index++) {
    const minDateMonthDate = flatbizDate.format(minDate, 'YYYY-MM');
    // 直接使用 minDate，当minDate 为 xxxx-01-29时，月份增加会出现无2月情况
    const monthDate = flatbizDate.update(`${minDateMonthDate}-01`, 'm', index);
    monthList.push({
      index,
      month: flatbizDate.format(monthDate, 'YYYY年MM月'),
      monthDate: monthDate,
      dayList: calculateMonthWeekList(monthDate, {
        weekType,
        isFill,
        minDate,
        maxDate,
      }),
    });
  }
  return monthList;
};
